/**
 * サニタイジングを行います。
 */
window.sanitaize = {
    /**
     * サニタイズ(エンコード)処理を行います。
     * @param {*} str
     */
    encode : function (str) {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },

    /**
     * サニタイズ(デコード)処理を行います
     * @param {*} str
     */
    decode : function (str) {
        return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'').replace(/&amp;/g, '&');
    }
};

/**
 * 郵便番号を整形します。
 * @param {*} str
 */
window.toZipcodeFormat = function(str) {
    if(str.trim().length == 7 && !isNaN(str)){
    str = str.trim();
    return str.substr(0,3) + "-" + str.substr(3);
    }
    return str;
}

/**
 * 住所からエリアコードを取得
 * @param {*} address
 * @param {*} messages
 */
window.getDestinationArea = function(address, messages) {

    address = (address || '').trim();
    if (address == ''){
        return '';
    }

    let areas = messages.destination_areas;

    for (key in areas) {
        let area = areas[key];
        for (prefix of area['prefix']) {

            if ((prefix || '').trim() != '' && address.startsWith(prefix.trim())) {
                return key;
            }
        }
    }
    return '99';
}

/**
 * 動態設定判定処理を行います。
 * @param {*} section_id
 * @param {*} category_key
 * @param {*} item_key
 * @param {*} movement_settings
 */
window.checkMovementSetting = function(section_id, category_key, item_key, movement_settings)
{
    if (movement_settings) {
        section_id  = (section_id || '').toString().trim();
        //let setting = JSON.parse((section_id != '') ? movement_settings[section_id] : movement_settings[Object.keys(movement_settings)[0]]);
        let setting = (section_id !== '') ? movement_settings[section_id] : movement_settings[Object.keys(movement_settings)[0]];
        if (setting && setting[category_key]){
            if (setting[category_key][item_key]) {
                return (setting[category_key][item_key] || false);
            } else if ((item_key || '').toString().trim() === '') {
                /** 項目キーが未指定の場合はカテゴリーは以下の全項目の設定値を判定する(true:全てorいずれかがON、false:全てOFF) */
                let exists = false;
                Object.keys(setting[category_key]).forEach(function(key) {
                    if((setting[category_key][key] && (setting[category_key][key] || '0') !== '0')){
                        exists = true;
                        return;
                    }
                });
                return exists;
            }
        }
    }
    return false;
}

/**
 * 文字列の自然順比較を行います。
 * @param {*} string1
 * @param {*} string2
 */
window.naturalStringCompare = function(string1, string2)
{
    let reg1, reg2, result1, result2, number1, number2, token1, token2, diff;
    string1 = zenkakuToHankaku(String(string1));
    string2 = zenkakuToHankaku(String(string2));

    if (string1 === string2) {
        return 0;
    }

    reg1 = /(\d+(?:\.\d+)?)|\D+/g;
    reg2 = /(\d+(?:\.\d+)?)|\D+/g;

    while (result1 = reg1.exec(string1), result2 = reg2.exec(string2), result1 && result2) {
        number1 = result1[1];
        number2 = result2[1];
        if (number1 && number2) {
            diff = number1 - number2; // ToNumber
            if (diff) {
                return diff;
            }
        } else {
            token1 = result1[0];
            token2 = result2[0];
            if (token1 !== token2) {
                return token1 > token2 ? 1 : -1;
            }
        }
    }

    if (!result1) {
        return result2 ? -1 : 0;
    }

    return 1;
};

/**
 * 全角→半角変換を行います。
 * @param {*} str
 */
window.zenkakuToHankaku = function(str)
{
    var hankaku = '';
    str.split('').forEach(function (s) {
        hankaku += String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    return hankaku;
}

